class scrollHelper {
	constructor() {
		this.checkIfScrolling();
	}

	to(el, tar, buff) {
		$(el).click(function (e) {
			e.preventDefault();
			var target = typeof tar === 'undefined' ? $(this).attr('href') : tar,
				buffer = typeof buff === 'undefined' ? parseInt($('body').css('margin-top')) : buff,
				scrollDest = parseInt($(target).offset().top - buffer);
			$('html, body').animate({
				scrollTop: scrollDest,
			}, 1000);
		});
	}

	checkIfScrolling() {
		this.scrollCheck();
		window.onscroll = () => {
			this.scrollCheck();
		};
	}

	scrollCheck() {
		// TODO: make this smoother

		let headerElem = document.getElementById('main-header');
		let scrollingClassName = 'scrolling';
		if (headerElem) {
			if (window.scrollY > 0) {
				// not at the top and scrolling
				headerElem.classList.add(scrollingClassName);
			} else {
				headerElem.classList.remove(scrollingClassName);
			}
		}
	}
}

window.app.add('scroll', new scrollHelper());
